import React from "react";
import "../../Styles/yellowcalf.css/Wallet_sale.css";
import userImg from "../../images/user.png";
import { Link } from "react-router-dom";

function Wallet_sale() {
  return (
    <div className="wallet-main-content" style={{ paddingTop: "25px" }}>
      <div className="wallet-main-container">

       
        <div className="wallet-main-panel wallet-main-page-header">
          <div className="wallet-main-panel-body">
            <div className="wallet-main-customer-index">
              <h3 className="wallet-main-title">Wallet Sales</h3>
              <div className="wallet-main-btn-group" >
                <button
                  className="wallet-main-btn-warning dropdown-toggle"
                  data-bs-toggle="dropdown"
                >
                  Export <i className="fa fa-angle-down"></i>
                </button>
                <ul className="wallet-main-dropdown dropdown-menu dropdown-menu-end">
                  <li>
                    <a className="wallet-main-item" href="#">
                      Save as PDF
                    </a>
                  </li>
                  <li>
                    <a className="wallet-main-item" href="#">
                      Save as PNG
                    </a>
                  </li>
                  <li>
                    <a className="wallet-main-item" href="#">
                      Save as CSV
                    </a>
                  </li>
                  <li>
                    <a className="wallet-main-item" href="#">
                      Save as TXT
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        
        <div className="wallet-main-panel">
          <div className="wallet-main-panel-body">
            <div className="wallet-main-table-wrapper">
              <table className="wallet-main-table">
                <thead>
                  <tr>
                    <th>Sr.No</th>
                    <th>Image</th>
                    <th>Student</th>
                    <th>Amount</th>
                    <th>Description</th>
                    <th>Date Time</th>
                    <th>&nbsp;</th>
                  </tr>
                </thead>
                <tbody>
                  {[1, 2, 3, 4, 5].map((i) => (
                    <tr key={i}>
                      <td>{i}</td>
                      <td>
                        <img
                          src={userImg}
                          width="35"
                          height="35"
                          alt="User"
                          className="wallet-main-img"
                        />
                      </td>
                      <td>Mayank</td>
                      <td>$ 500</td>
                      <td>Balance adjusted to invoice payment</td>
                      <td>Wed Sep 25 2024 10:50:54 AM</td>
                      <td>
                        <Link
                          to="/walletreceipt"
                          className="wallet-main-btn-green"
                          title="view"
                        >
                          <i class="bi bi-eye"></i>
                        </Link>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className="wallet-main-footer">
              <ul className="wallet-main-pagination">
                <li className="wallet-main-active">
                  <a href="#">1</a>
                </li>
                <li>
                  <a href="#">2</a>
                </li>
                <li>
                  <a href="#">3</a>
                </li>
              </ul>

              <div className="wallet-main-summary">
                Showing <b>1-50</b> of <b>177</b> items.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Wallet_sale;
